// src/layouts/bottlenecks/fetchBottlenecks.js
import axios from "axios";
import config from "config";

const API_URL = `${config.TRAFFIC}/latest_bottlenecks`;

const CLASS_COLORS = {
  0: "#12B51A", // Free Flow
  1: "#C74811", // Congested
  2: "#E98500", // Near Congestion
  3: "#FFEB3B", // Stable Flow
};

const CLASS_LABELS = {
  0: "Free Flow",
  1: "Congested",
  2: "Activation",
  3: "De-activation",
};

function formatTimestamp(timestamp) {
  if (!timestamp) return null;
  const d = new Date(timestamp);
  if (Number.isNaN(d.getTime())) return null;

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}`;
}


function buildGeoJSON(bottlenecksArray) {
  return {
    type: "FeatureCollection",
    features: (bottlenecksArray || [])
      .filter(Boolean)
       .map((b, idx) => {
        const formattedDate = formatTimestamp(b.timestamp);
        return {
          type: "Feature",
          id: b.path_id ?? idx,
          geometry: b.merged_geom,
          properties: {
            path_id: b.path_id,
            predicted_class: b.predicted_class,
            color: CLASS_COLORS[b.predicted_class] || "#888888",
            label: CLASS_LABELS[b.predicted_class] || "",
            timestamp: b.timestamp,
            date: formattedDate,           
          },
        };
      }),
  };
}

export async function fetchLatestBottlenecks() {
  const response = await axios.get(API_URL, {
    headers: { "accept-profile": "traffic_monitoring" },
  });

  const items = response.data || [];  
  const geojson = buildGeoJSON(items);

  return geojson;
}
